import styles from "./FamilyGroupTabs.module.css";
import { Button } from "../../../UI";

interface FamilyGroupTab {
    title: string;
    setTab: string;
}

interface FamilyGroupTabsProps {
    tabs: FamilyGroupTab[];
    activeTab: string;
    changeActiveTab: (tab: string) => void;
}

export const FamilyGroupTabs = ({ tabs, activeTab, changeActiveTab }: FamilyGroupTabsProps) => {
    return (
        <div className={styles.tabs}>
            {tabs.map((tab) => (
                <button
                    key={tab.setTab}
                    onClick={() => changeActiveTab(tab.setTab)}
                    className={`${styles.tab} ${activeTab === tab.setTab ? styles.active : ''}`}
                >
                    {tab.title}
                </button>
            ))}
        </div>
    );
};
